import { render } from "./AcademicWeekdayPreSchool.vue?vue&type=template&id=6b99aafc&scoped=true"
import script from "./AcademicWeekdayPreSchool.vue?vue&type=script&lang=js"
export * from "./AcademicWeekdayPreSchool.vue?vue&type=script&lang=js"

import "./AcademicWeekdayPreSchool.vue?vue&type=style&index=0&id=6b99aafc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b99aafc"]])

export default __exports__